const CHECKBOX_FIELD_TYPES = new Set(["checkbox", "newCheckbox"]);
const SKIP_CHECKBOX_FIELD_TYPES = new Set([
  "checkbox-group",
  "newCheckbox-group"
]);

export default function authFormFieldsToRequestData(fields) {
  const requestData = {};

  fields.forEach(field => {
    if (SKIP_CHECKBOX_FIELD_TYPES.has(field.type)) {
      return;
    }

    if (CHECKBOX_FIELD_TYPES.has(field.type)) {
      requestData[field.name] = Boolean(field.selected?.length);
      return;
    }

    requestData[field.name] = field.value;
  });

  return requestData;
}
